import { AnalyticsEvent } from '.'

export const SpeedTestQuestionsTappedEvent = (): AnalyticsEvent => {
  return {
    name: 'Speed check questions tapped',
  }
}

export const RunSpeedCheckTappedEvent = (): AnalyticsEvent => {
  return {
    name: 'Run speed check button tapped',
  }
}

export const CheckAgainTappedEvent = (): AnalyticsEvent => {
  return {
    name: 'Check again button tapped',
  }
}

export const SpeedTestCompletedEvent = (
  download: number,
  upload: number,
  ping: number,
  sortedServer: string | undefined,
  provider: string | undefined,
  clientIP: string | undefined,
  guid: string | undefined
): AnalyticsEvent => {
  return {
    name: 'Speed check complete',
    extras: {
      Download: download,
      Upload: upload,
      Ping: ping,
      Server: sortedServer,
      Provider: provider,
      IPAddress: clientIP,
      Guid: guid,
    },
  }
}

export const ExperiencingNetworkIssueTappedEvent = (): AnalyticsEvent => {
  return {
    name: 'Experiencing network issue tapped',
  }
}
